import React from "react"

export default function ChartTooltip({ tooltip, transition = true }) {
  if (!tooltip || !tooltip.visible) return null

  const { x, y, content, visible } = tooltip
  
    return (
      <div
        style={{
          position: "fixed",
          left: x,
          top: y,
          // Always pass pointer events through to the chart underneath.
          // The chart anchors the tooltip above the snapped data point,
          // so the tooltip can overlap the cursor; capturing events here
          // would cause the underlying SVG to see pointerleave and the
          // tooltip would flicker on/off as it appears and disappears.
          pointerEvents: "none",
          background: "#fff",
          color: "#000",
          border: "1px solid #ccc",
          padding: "6px 8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.25)",
          borderRadius: "4px",
          fontSize: "12px",
          zIndex: 9999,
          opacity: visible ? 1 : 0,
          transform: "translate(-50%, -100%)",
          transition: transition ? "all .2s ease-in-out" : "none",
          // Keep the tooltip's intrinsic size constant regardless of where
          // it appears. Without this, `position: fixed` lets the content
          // box's available width collapse to the gap between `left` and
          // the viewport's right edge, which silently wraps lines and
          // makes tooltips near the right side render narrower.
          whiteSpace: "nowrap",
          width: "max-content",
          maxWidth: "none",
          willChange: "transform, opacity, left, top",
        }}
        role="tooltip"
      >{content}</div>
    );
  }